import { Deserialize } from 'cerialize'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { getLocaleMessages } from 'Src/locale'
import {
	NOTIFICATION_TYPE,
	showNotificationAction,
	ErrorCode,
	ResponseMethod,
	ResponseError,
	PrepareErrorOptions,
	ServerError,
	formsSelectors,
} from 'Modules'
import { all, call, put, select } from 'typed-redux-saga'
import { authSlice } from 'Pages/auth'

export function* errorHandler(error: any, formName?: string, options?: PrepareErrorOptions) {
	if (!error || !error?.status) {
		const { errors } = getLocaleMessages('ru')
		yield* call(showError, `${errors.internal_error}`)
		// eslint-disable-next-line no-console
		console.log(error)
		return
	}
	const handleError = Deserialize(error, ResponseError)
	if (options) {
		const { keyCodes, substitutedValue } = options
		const keys = handleError.getKeys()
		keys.forEach((key): void => {
			if (keyCodes.includes(key)) {
				handleError.setError(key, substitutedValue)
			}
		})
	}
	const { status } = handleError
	switch (status) {
		case ErrorCode.e500:
		case ErrorCode.e502:
		case ErrorCode.e503:
			return yield* put(routerActions.push(FrontUrls.pages.page_500))
		case ErrorCode.e401:
			yield* put(authSlice.actions.logout())
			break
		case ErrorCode.e403:
			return yield* put(routerActions.push(FrontUrls.pages.page_403))
		case ErrorCode.e404:
			return yield* put(routerActions.push(FrontUrls.pages.page_404))
		case ErrorCode.e422:
			yield* call(formErrorHandler, handleError, formName)
			break
		default:
			yield* call(showError, getErrorsNotifications()[0])
	}
}

function* formErrorHandler(errorObj: ResponseError, formName?: string) {
	const { method, errors } = errorObj
	let notifications: string[]
	const getForm = yield* select(formsSelectors.getGlobalForm)
	const form = getForm(formName)
	switch (method) {
		case ResponseMethod.GET:
			notifications = getErrorsNotifications(errors)
			break
		case ResponseMethod.POST:
		case ResponseMethod.PUT:
		case ResponseMethod.PATCH:
			notifications = form
				? sendFormErrorsAndReturnErrorsNotifications(errors, form)
				: getErrorsNotifications(errors)
			break
		default:
			notifications = getErrorsNotifications(errors)
	}
	yield* all(notifications.map((item) => call(showError, item)))
}

export function translateErrorMessage(error?: ServerError): string {
	const [key, value] = error ? Object.entries(error)[0] : []
	const { errors } = getLocaleMessages('ru')
	return errors[`${key}.${Array.isArray(value) ? value[0] : value}`] || errors.unknown_error
}

export function getErrorsNotifications(errors?: ServerError[]): string[] {
	if (!errors || !errors.length) return [translateErrorMessage()]
	return errors.map((error): string => translateErrorMessage(error))
}

export function sendFormErrorsAndReturnErrorsNotifications(
	errors: ServerError[],
	form: any
): string[] {
	const { setFields, getFieldValue, getFieldInstance } = form
	return errors.reduce((acc, error): string[] => {
		const key = Object.keys(error)[0]
		const errorMessage = translateErrorMessage(error)
		if (getFieldInstance(key)) {
			setFields({
				[key]: {
					value: getFieldValue(key),
					errors: [new Error(errorMessage)],
				},
			})
		} else {
			acc.push(errorMessage)
		}
		return acc
	}, [])
}

export function* showError(message: string) {
	yield* put(showNotificationAction({ type: NOTIFICATION_TYPE.ERROR, message }))
}
